import { render, staticRenderFns } from "./AddCandidateToBatch.vue?vue&type=template&id=512250d3&"
import script from "./AddCandidateToBatch.vue?vue&type=script&lang=js&"
export * from "./AddCandidateToBatch.vue?vue&type=script&lang=js&"
import style0 from "./AddCandidateToBatch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports